import { Badge, BadgeVariants } from '@/components/notifications/Badge/Badge';
import { AssetValuationV2ValuationReason } from '@/types/schema';

const copy: Record<AssetValuationV2ValuationReason, string> = {
  [AssetValuationV2ValuationReason.GratAnnuityPayment]: 'Annuity Payment',
  [AssetValuationV2ValuationReason.AssetRevaluation]: 'Asset Revaluation',
  [AssetValuationV2ValuationReason.InitialFunding]: 'Initial Funding Value',
  [AssetValuationV2ValuationReason.GratAssetSubstitution]: 'Asset Substitution',
  [AssetValuationV2ValuationReason.GratRemainderDistribution]:
    'Remainder Distribution',
};

const styles: Record<AssetValuationV2ValuationReason, BadgeVariants> = {
  [AssetValuationV2ValuationReason.GratAnnuityPayment]: BadgeVariants.Warning,
  [AssetValuationV2ValuationReason.AssetRevaluation]:
    BadgeVariants.SecondaryFilled,
  [AssetValuationV2ValuationReason.InitialFunding]: BadgeVariants.Success,
  [AssetValuationV2ValuationReason.GratAssetSubstitution]:
    BadgeVariants.Success,
  [AssetValuationV2ValuationReason.GratRemainderDistribution]:
    BadgeVariants.Success,
};

interface Props {
  reason: AssetValuationV2ValuationReason;
}

export function ValuationReasonLabel({ reason }: Props) {
  return (
    <Badge
      variant={styles[reason]}
      display={copy[reason]}
      textTransform="none"
    />
  );
}
